// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.side-nav .menu-title{\n    display: block;\n    font-size: 14px;\n    padding: 12px 12px 12px 30px;\n    position: relative;\n    text-decoration: none;\n    color: #c7cbd1;\n    cursor: pointer;\n}\n.side-nav .menu-title:hover{\n    background-color: #505862;\n}\n", ""]);
// Exports
module.exports = exports;
